import * as React from "react";
import * as ReactDOM from "react-dom";
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ThemeProvider } from "@mui/material";
import { Subscription } from "rxjs";
import { Chanels } from "../chanels";
import { EntityService } from "../entity/entity.service";
import { SiteService } from "../entity/site.service";
import { theme } from "../react-theme";
import { SignalsService } from "../signals/signals.service";
import { Guid } from "../system/guid";
import { ServiceBusService } from "../system/service-bus.service";
import NotificationsPage from "./components/SurveillanceReportsPage";
import { TempreportService } from "../reports/tempreport.service";
import { EntityDeviationService } from "../entity-deviation-service";
import { AlarmsService } from "../alarms.service";

const containerElementName = "myReactComponentContainer";

@Component({
  selector: "app-my-component",
  template: `<span #${containerElementName}></span>`,
  encapsulation: ViewEncapsulation.None,
})
export class SurveillanceReportsComponent
  implements OnChanges, OnDestroy, AfterViewInit {
  @ViewChild(containerElementName) containerRef: ElementRef;

  siteId: Guid;

  public isLoadingEntities = true;

  private userSubscription: Subscription;

  private user: any;

  constructor(
    private bus: ServiceBusService,
    private entityService: EntityService,
    private signalsService: SignalsService,
    private siteService: SiteService,
    private tempReportService: TempreportService,
    private entityDeviationService: EntityDeviationService,
    private alarmService: AlarmsService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    console.log(React); // DO NOT REMOVE - to prevent aot from removing react
    this.userSubscription = this.bus
      .chanelObservable(Chanels.USER_CHANEL)
      .subscribe((user) => {
        this.user = user;
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.render();
  }

  ngAfterViewInit() {
    this.render();
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
    ReactDOM.unmountComponentAtNode(this.containerRef.nativeElement);
  }

  private render() {
    ReactDOM.render(
      <ThemeProvider theme={theme}>
        <SurveillanceReportsContext.Provider
          value={{
            user: this.user,
            entityService: this.entityService,
            signalsService: this.signalsService,
            siteService: this.siteService,
            tempReportService: this.tempReportService,
            entityDeviationService: this.entityDeviationService,
            alarmService: this.alarmService,
            router: this.router,
            route: this.route,
          }}
        >
          <NotificationsPage />
        </SurveillanceReportsContext.Provider>
      </ThemeProvider>,
      this.containerRef.nativeElement
    );
  }
}

type SurveillanceReportsContextTypes = {
  user: any;
  entityService: EntityService;
  signalsService: SignalsService;
  siteService: SiteService;
  tempReportService: TempreportService;
  entityDeviationService: EntityDeviationService;
  alarmService: AlarmsService;
  router: Router;
  route?: ActivatedRoute;
};

export const SurveillanceReportsContext = React.createContext<SurveillanceReportsContextTypes>(
  undefined
);
